import { makeStyles } from '@mui/styles';
import { theme } from '~/theme/default';
const border = {
    borderWidth: '1px',
    borderColor: theme.palette.grey['100'],
    borderStyle: 'solid',
};
export const useStyles = makeStyles(() => ({
    header: {
        height: '48px',
        backgroundColor: theme.palette.grey['200'],
        ...border,
    },
    cell: {
        paddingLeft: '16px',
    },
    row: {
        ...border,
        minHeight: '48px',
    },
}));
